export default {
  form: {
    amount: {
      label: 'Prijs',
    },
    has_sales_based_discount: {
      label: 'Kortingen op basis van maandelijkse omzet',
    },
  },
  labels: {
    month: 'maand',
    varies_by_tier: 'varieert per niveau',
    max_price: '* Maximumprijs is {{amount}}',
    sales_based_discount: 'tot +{{threshold}} minimale omzet per maand. Daarna reguliere prijs {{amount}} netto/maand',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (inbegrepen)',
    exclusive: 'per maand plus {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Selecteren',
    save: 'Opslaan',
    use_default_price: 'Standaardprijs gebruiken',
  },
};
